import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { getArticleById } from "@/utils/content";

const sideIds = [
  "daiyan-san-jia-zheng",
  "zongyi-jianji-taoben",
  "hangye-shuju-koubei",
  "juzu-yeban-huanren",
];

export default function HomeFeatured() {
  const featured = getArticleById("hangye-resou-lujing");
  const side = sideIds
    .map((id) => getArticleById(id))
    .filter((item): item is NonNullable<typeof item> => Boolean(item));

  if (!featured) return null;

  return (
    <section className="w-full bg-background-50 py-14 md:py-20" id="featured">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Deep Dive"
          title="深扒解读"
          description="不只告诉你发生了什么，更想说说这件事为什么会上热搜、后面又会怎么走。"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:col-span-7">
            <Link to={`/article/${featured.id}`} className="block h-64 w-full overflow-hidden md:h-80">
              <img
                src={featured.image}
                alt={featured.imageAlt}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </Link>
            <div className="p-5 md:p-7">
              <span className="inline-block rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
                {featured.topicName}
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                <Link to={`/article/${featured.id}`} className="transition-colors hover:text-primary-700">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
              <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-3-line"></i> {featured.author}
                </span>
                <span>{featured.date}</span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-fire-line"></i> {featured.views} 阅读
                </span>
                <Link
                  to={`/article/${featured.id}`}
                  className="ml-auto inline-flex items-center gap-1 whitespace-nowrap font-medium text-primary-700 hover:text-primary-800"
                >
                  读全文 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </article>

          <div className="rounded-lg border border-background-200 bg-background-100/60 p-4 md:p-5 lg:col-span-5">
            <h3 className="mb-2 font-heading text-base font-bold text-foreground-950">
              编辑也在看
            </h3>
            <div>
              {side.map((article) => (
                <ArticleCard key={article.id} article={article} variant="row" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}